import Common from "./Common";
import Homepage from "./pages/Homepage";
import ProductList from "./pages/ProductList";
import Workshop from "./pages/Workshop";
import About from "./pages/About";

import CustomProductPage from "./pages/CustomProductPage";
import SimpleProductPage from "./pages/SimpleProductPage";
import CartPage from "./pages/CartPage";


// import "bootstrap/dist/js/bootstrap.bundle.js";
import * as bootstrap from "bootstrap";
// import { Collapse, Popover } from "bootstrap";

window.addEventListener("load", () => {
  let common = new Common();
  common.init();

  const pageHomeDOM = document.querySelector("#page-home");
  if (pageHomeDOM) {
    let pageHome = new Homepage(pageHomeDOM);
    pageHome.init();
  }

  const pageProductListDOM = document.querySelector(".product-li");
  if (pageProductListDOM) {
    let pageProductList = new ProductList(pageProductListDOM);
    pageProductList.init();
  }

  const pageAboutDOM = document.querySelector("#page-about");
  if (pageAboutDOM) {
    let pageAbout = new About(pageAboutDOM);
    pageAbout.init();
  }

  const pageWorkshopDOM = document.querySelector(
    "#page-workshop-details_01"
  );
  if (pageWorkshopDOM) {
    let pageWorkshop = new Workshop(pageWorkshopDOM);
    pageWorkshop.init();
  }

  const custProductPage = document.querySelector("#page-cust-product");
  if (custProductPage) {
    let pageCustProduct = new CustomProductPage(custProductPage);
    pageCustProduct.init();

    const btnGetConfig = document.querySelector("[js-getConfig]");
    btnGetConfig.addEventListener("click", () => {
      pageCustProduct.getFullConfig();
    });
  }

  const simpleProductPage = document.querySelector("#page-simple-product");
  if (simpleProductPage) {
    let pageSimpleProduct = new SimpleProductPage(simpleProductPage);
    pageSimpleProduct.init();
  }

  const cartPageDOM = document.querySelector('#page-cart');
  if(cartPageDOM){
    let cartPage = new CartPage(cartPageDOM);
    cartPage.init();
  }
});
